module.exports = __webpack_public_path__ + "img/op-unselect.svg";